import { axiosAuth } from "./axiosApi";
import { API_PATHS } from "./constants";

export const telegramList = async () =>
  axiosAuth.get(`${API_PATHS.TELEGRAM_LIST}`);

export const createTelegramChannel = async (data) =>
  axiosAuth.post(`${API_PATHS.TELEGRAM_CREATE_CHANNEL}`, data);

export const createChannel = async (data) =>
  axiosAuth.post(`${API_PATHS.TELEGRAM_LIST}`, data);
